import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ShieldAlert, Home, LogOut } from 'lucide-react';
import { useAuth } from '../context/useAuth';

const Unauthorized = () => {
    const navigate = useNavigate();
    const { logout } = useAuth();

    return (
        <div className="flex flex-col items-center justify-center h-screen bg-slate-50 p-6 text-center">
            <div className="bg-white p-8 rounded-2xl shadow-xl border border-slate-200 max-w-md w-full">
                <div className="flex justify-center mb-6">
                    <div className="p-4 bg-red-50 text-red-600 rounded-full">
                        <ShieldAlert size={48} />
                    </div>
                </div>
                
                <h1 className="text-6xl font-black text-slate-900 mb-2">403</h1>
                <h2 className="text-xl font-bold text-slate-800 mb-2">Access Denied</h2>
                <p className="text-slate-500 mb-8">
                    You don't have the necessary permissions to access this specific module. 
                    Please contact the administrator if you believe this is an error.
                </p>

                <div className="flex flex-col gap-3">
                    <button 
                        onClick={() => navigate('/dashboard')}
                        className="flex items-center justify-center gap-2 bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-xl font-bold transition-all"
                    >
                        <Home size={18} />
                        Return to Dashboard
                    </button>
                    
                    <button 
                        onClick={logout}
                        className="flex items-center justify-center gap-2 bg-white border border-slate-200 text-slate-600 hover:bg-slate-50 px-6 py-3 rounded-xl font-bold transition-all"
                    >
                        <LogOut size={18} />
                        Sign Out
                    </button>
                </div>
            </div>
        </div>
    );
};

export default Unauthorized;